import React, { Component } from "react";
import CuadreEfectivo from "./cuadreEfectivo";

class Index extends Component {
  render() {
    return (
      <div>
        <CuadreEfectivo />
      </div>
    );
  }
}
export default Index;
